/*@flow*/
import L from 'leaflet';
import { TileJSONLayer, tileJSON } from 'lib/leaflet-plugins/TileJSONLayer';
import type { DeckPropsT } from '../types';
import { useEffect, useState } from 'react';
import useLayer from '../useLayer';

type OptionsT = {| url: ?string, json: ?Object |};
const defaults = { minZoom: 1, maxZoom: 22 };

type TileJSONLayerT = {
  setUrl: (url: string) => void,
};

export default (props: DeckPropsT<OptionsT>) => {
  const { options } = props;
  const [element, setElement] = useState();
  let { url, json } = options;
  let o = { ...defaults, ...options };

  // Create the tile layer and set it as element.
  useEffect(() => {
    if (!url) return;
    if (element) return;

    let e: TileJSONLayerT;
    if (url.match(/\{x\}/)) {
      e = L.tileLayer(url, o);
    } else {
      e = tileJSON({ url, json }, o);
    }
    setElement(e);
  }, [url]);

  // Add/remove layer.
  useLayer<OptionsT>(props, element);

  // Set the url of the tile
  useEffect(() => {
    if (!element) return;
    if (!url) return;
    if (url.match(/\{x\}/)) {
      element.setUrl(url);
    } else {
      TileJSONLayer.prototype.setUrl.call(element, url);
    }
  }, [url, element]);
};
